package com.gsb.vyapar.bhagya.datasource.network.response

import kotlinx.serialization.Serializable

@Serializable
data class RefreshAuthResponse(
    val expires_in: String? = null,
    val token_type: String? = null,
    val refresh_token: String? = null,
    val id_token: String? = null,
    val user_id: String? = null,
    val project_id: String? = null
)